import { jsx as l, jsxs as x } from "react/jsx-runtime";
import { Tooltip as m } from "@systemeio/ui";
import { useEditorState as T } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useMemo as I } from "react";
import { useTranslation as P } from "../../i18n.mjs";
import { twMerge as g } from "tailwind-merge";
import { ToolbarButton as f } from "../../components/content-controls/toolbar-button.mjs";
import { TOOLTIP_STYLES as h, getToolbarIconFillClassName as u } from "../../constants/default-styles.mjs";
import b from "../../icons/paragraph-space-icon.mjs";
import { PARAGRAPH_EXTRA_SPACING_ATTRIBUTE as v } from "./constants.mjs";
import { isImageSelected as C } from "../image-extension/utils/is-image-selected.mjs";
const A = (r) => r.attrs[v], E = (r, t, n) => {
  if (!r || t === void 0 || n === void 0) return !1;
  if (t === n)
    return r.isActive("paragraph");
  let a = !1;
  return r.state.doc.nodesBetween(t, n, (s) => {
    if (s.type.name === "paragraph")
      return a = !0, !1;
  }), a;
}, d = (r, t, n) => {
  if (!r || t === void 0 || n === void 0) return !1;
  if (t === n) {
    const s = r.state.doc.resolve(t);
    for (let c = s.depth; c >= 0; c--) {
      const o = s.node(c);
      if (o.type.name === "paragraph")
        return A(o);
    }
    return !1;
  }
  let a = !1;
  return r.state.doc.nodesBetween(t, n, (s) => {
    if (s.type.name === "paragraph")
      return a = A(s), !1;
  }), a;
}, L = (r, t) => {
  const { t: n } = P(), a = T({
    editor: r,
    selector: ({ editor: e }) => {
      const p = e == null ? void 0 : e.state.selection.from, i = e == null ? void 0 : e.state.selection.to;
      return {
        isEditable: (e == null ? void 0 : e.options.editable) ?? !1,
        isImageSelected: C(e),
        hasParagraphContext: E(e, p, i),
        isActive: d(e, p, i)
      };
    }
  }), s = !(a != null && a.isEditable) || !!(a != null && a.isImageSelected) || !(a != null && a.hasParagraphContext), c = (a == null ? void 0 : a.isActive) ?? !1;
  return I(() => {
    const e = () => {
      r && r.chain().focus().updateAttributes("paragraph", {
        [v]: !c
      }).run();
    };
    return {
      toolbarRender: /* @__PURE__ */ l(
        m,
        {
          disabled: s,
          label: n("extra_spacing"),
          ...h,
          children: /* @__PURE__ */ l(
            f,
            {
              disabled: s,
              onClick: e,
              className: g(c && "bg-brand-primary/10 main-transition-colors"),
              children: /* @__PURE__ */ l(b, { className: u(s) })
            }
          )
        },
        "paragraph-spacing"
      ),
      tooltipRender: /* @__PURE__ */ l(
        m,
        {
          disabled: s,
          label: n("extra_spacing"),
          ...h,
          children: /* @__PURE__ */ x(
            f,
            {
              disabled: s,
              onClick: e,
              className: g(
                c && "bg-brand-primary/10 main-transition-colors",
                "flex gap-1"
              ),
              children: [
                /* @__PURE__ */ l(b, { className: u(s) }),
                n("extra_spacing")
              ]
            }
          )
        },
        "paragraph-spacing"
      )
    };
  }, [r, c, s, t, n]);
};
export {
  L as useParagraphSpaceExtensionToolbar
};
